const yesNoDurableInvestment = {
    yes: 'Oui',
    no: 'Non',
};

export default yesNoDurableInvestment;
